import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {IEvent} from '@app/models/v3/event-log';

@Component({
  selector: 'app-event-log-viewer',
  templateUrl: './event-log-viewer.component.html',
  styles: []
})
export class EventLogViewerComponent {
  @Input() events!: IEvent[];
  @Input() showHeader = true;
  @Input() title: string;

  showDialog = false;

  selectedMessage = {
    message: '',
    action: '',
    diffItems: [] as { field: string, oldValue: string, newValue: string }[]
  };

  constructor() {
  }

  openMessageDialog(message: string) {
    this.selectedMessage = {
      message,
      action: this.getAction(message),
      diffItems: this.parseDiffText(message)
    };
    this.showDialog = true;
  }

  getAction(fullMessage: string): string {
    const match = fullMessage.match(/^([\w\s]+?)\s*-\s*Diff:/);
    return match ? match[1].trim() : '';
  }

  private parseDiffText(text: string) {
    const lines = text.split('\n').filter(line => line.trim().startsWith('- '));
    return lines.map(line => {
      const match = line.match(/- '(.*)' changed: '(.*)' -> '(.*)'/);
      if (match) {
        const [, field, oldValue, newValue] = match;
        return { field, oldValue, newValue };
      }
      return null;
    }).filter(item => item !== null) as { field: string, oldValue: string, newValue: string }[];
  }
}
